import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"

const WaitingListHero = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    })
  }, []);

  return (

  <section className="hero bg-gradient-to-br from-purple-600 to-pink-500 text-white py-32 text-center px-6">
    <h1 className="text-4xl md:text-5xl font-bold mb-4" data-aos="fade-down" data-aos-delay="150">
      Be Among the First to Test <span className="text-yellow-300">BeatsFussion</span>!
    </h1>
    <p className="text-lg md:text-md max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="250">
      Join the exclusive beta waitlist for the first-of-its-kind dance battle app. Get early access, help shape the experience, and win cool rewards along the way.
    </p>
    <a href="#signup" className="mt-6 inline-block bg-white text-purple-700 font-bold px-6 py-3 rounded-full shadow-lg hover:bg-gray-100 transition" data-aos="zoom-in" data-aos-delay="400">
      Join the Waitlist
    </a>
  </section>
  )

};

export default WaitingListHero;
